var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ColorPicker = function ColorPicker(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 3.586a2 2 0 0 1 2.8 0l.007.007L20.414 6.2a2 2 0 0 1 0 2.8l-.007.007L17.414 12l.293.293a1 1 0 0 1-1.414 1.414L16 13.414l-7.293 7.293A1 1 0 0 1 8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707L10.586 8l-.293-.293a1 1 0 1 1 1.414-1.414l.293.293 3-3Zm-3 5.828-7 7V19h2.586l7-7L12 9.414Zm4 1.172L13.414 8 16.4 5.014 18.986 7.6 16 10.586Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ColorPicker;